import './index.css'

import { MantineProvider } from '@mantine/core'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { isBeta } from './constants/env'
import { fetchPublicOriginalPost, fetchPublicRepost } from './utils/fetchers/publicPost'
import queryClient from './utils/queryClient'
import { initializePWAInstall } from './utils/PWAInstall'
import router from './utils/router'
import Sentry from './utils/sentry'
import theme from './utils/theme'
import { registerGetPostTool } from './utils/webmcp/getPostTool'
import { registerGetRepostTool } from './utils/webmcp/getRepostTool'

const disposePWAInstall = initializePWAInstall()
import.meta.hot?.dispose(disposePWAInstall)

Sentry.init()
if (isBeta) {
	void registerGetPostTool(document.modelContext, fetchPublicOriginalPost)
	void registerGetRepostTool(document.modelContext, fetchPublicRepost)
}

const root = createRoot(document.getElementById('root') as HTMLElement)

const App = Sentry.withProfiler(
	() => {
		return (
			<QueryClientProvider client={queryClient}>
				<MantineProvider theme={theme}>
					<RouterProvider router={router} />
				</MantineProvider>
			</QueryClientProvider>
		)
	},
	{
		name: 'App',
	}
)

root.render(
	<StrictMode>
		<App />
	</StrictMode>
)
